import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Paper
} from "@mui/material";
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { courseDiscussionCommentEditApi } from "../../store/course-discussion/editCourseDiscussionComment";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import { courseDiscussionCommentApi, resetCourseDiscussionComment } from "../../store/course-discussion/courseDiscussionCommentList"
import DataGridComponent from "../../components/DataGridComponent";
import { getGridStringOperators } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ThemeContext } from '../../context/ThemeContext';
import NodataImg from "../../assets/images/noData.png";
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import BackdropUI from "../../ui/Backdrop";

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import redFlag from "../../assets/icons/red_flag.png"


const schema = yup
  .object({
    youtube_link: yup.string().optional("Please Provide Video Link").nullable("").trim(),
    post_type: yup.string().optional("Please Provide Post Type").nullable("").trim(),
  })
  .required();

export default function EditCourseDiscussionComment() {

  const discussionCommentEdit = useSelector((state) => state?.courseDiscussionCommentEdit);
  const historyLocation = useLocation();
  const [deleteId, setDeleteId] = useState(null);
  const [notSelectedProductModel, setNotSelectedProductModel] = useState(false);
  const { postData, courseId: stateCourseId } = historyLocation.state || {};
  const [, setSelectedRow] = useState([]);

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(schema), defaultValues: {} });
  const [isDownload, setIsDownload] = useState(false)
  const params = useParams();
  const courseId = params.courseId || stateCourseId;
  const navigate = useNavigate();
  const { paginationModel, setPaginationModel } = useContext(ThemeContext)
  const [queryOptions, setQueryOptions] = useState({});
  const onFilterChange = useCallback((filterModel) => {
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);
  const commentSelector = useSelector((state) => state?.courseDiscussionComments);
  const { result, loading, total } = commentSelector;


  const handleUpdateForm = async (data) => {
    let newObj = { ...data };
    if (params.id) {
      const originalContent = postData?.content || postData?.description;
      if (newObj.content === originalContent) {
        navigate(`/courses/discussion/${courseId}`);
        return;
      }
      newObj = {
        content: newObj.content,
        comment_id: params.id
      };

      await dispatch(courseDiscussionCommentEditApi(newObj));
      if (!discussionCommentEdit?.loading) {
        navigate(`/courses/discussion/${courseId}`);
      }
    }
  };

  useEffect(() => {
    let defalutValues = {};
    defalutValues["content"] = postData?.content || postData?.comment;
    reset(defalutValues);
  }, [postData, reset]);


  const getDiscussionCommentList = useCallback((queryOptions, paginationModel) => {
    const filterModel = queryOptions?.filterModel;
    const items = filterModel?.items;
    const firstItem = items && items.length > 0 ? items[0] : {};
    const quickFilterValues = filterModel?.quickFilterValues;

    const query = {
      comment_id: params.id,
      page: paginationModel?.page + 1,
      page_size: paginationModel?.pageSize,
      field: firstItem.field || '',
      operator: firstItem.operator || (quickFilterValues && "contains") || '',
      value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || '',
      search: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
    };
    dispatch(courseDiscussionCommentApi(query));
  }, [dispatch, postData?.id])

  useEffect(() => {
    getDiscussionCommentList(queryOptions, paginationModel)
    dispatch(resetCourseDiscussionComment());
  }, [dispatch, queryOptions, paginationModel, getDiscussionCommentList]);

  const columns = [
    {
      field: "id",
      headerName: "Comment Id",
      filterable: false,
      sortable: false,
      width: 150,
      renderCell: (fieldData) => {

        return (
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flex: "auto"
          }}>
            <text>
              {fieldData.value}
            </text>
            <Box></Box>
          </Box >
        )
      }
    },
    {
      field: "content",
      headerName: "Comment",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 350,
    },
    {
      field: "user_name",
      headerName: "Added By",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 350,
    },
    {
      field: "update_discussion_comment",
      headerName: "Update comment",
      filterable: false,
      sortable: false,
      width: 150,
      disableExport: true,
      renderCell: (fieldData) => (
        <>
          <Button
            color="info"
            endIcon={<EditIcon />}
            label="Available" variant="outlined"
            onClick={() => navigate(
              `/courses/discussion/${courseId}/edit-discussion-comment-reply/${fieldData.id}`, {
              state: { postCommentData: fieldData.row, postId: params.id, postData, courseId, getDiscussionCommentList: JSON.stringify(getDiscussionCommentList) }
            }
            )}
          >
            Edit
          </Button>
        </>
      ),
    },

  ];

  return (
    <>
      <Appbar />
      <Drawer />
      <Body>
        <form onSubmit={handleSubmit(handleUpdateForm)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
                <Button
                  type="button"
                  startIcon={<ArrowBackIcon />}
                  sx={{ color: "black", fontSize: "14px", padding: 0, textTransform: "none", '&:hover': { background: 'none' } }}
                  onClick={() => navigate(`/courses/discussion/${courseId}`)}
                >
                  Back
                </Button>
              </Box>
              <Card>
                <Typography>Comment Details</Typography>
                <Stack spacing={2} sx={{ mt: 2, mb: 0 }}>
                  <Divider />
                  <>
                    <InputLabel htmlFor="outlined-adornment-content" shrink>
                      Content
                    </InputLabel>
                    <OutlinedInput
                      {...register("content")}
                      notched
                      multiline
                      id="outlined-adornment-content"
                      error={errors?.content?.message}
                      defaultValue={postData?.content || postData?.description}
                    />
                  </>
                </Stack>
                <Button
                  type="button"
                  sx={{ float: "right", mt: 2, ml: 2 }}
                  variant="contained"
                  onClick={() => navigate(`/courses/discussion/${courseId}`)}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  sx={{ float: "right", mt: 2 }}
                  variant="contained"
                >
                  Update
                </Button>
              </Card>
              <br />
              <br />
              {params.id && (<>
                <Card>
                  <Typography>Replies details</Typography>
                  <Paper elevation={0}>
                    <DataGridComponent
                      loading={loading}
                      rowCount={total}
                      pageSizeOptions={[5, 10, 20, 50, 100]}
                      pageSize={paginationModel?.pageSize}
                      onPageSizeChange={(newPageSize) => {
                        setPaginationModel({
                          ...paginationModel,
                          pageSize: newPageSize,
                        })
                      }}
                      paginationModel={paginationModel}
                      onPaginationModelChange={setPaginationModel}
                      pagination
                      paginationMode="server"
                      sx={{
                        height: 500
                      }}
                      getRowId={(row) => row.id}
                      rows={result}
                      columns={columns}
                      disableColumnSelector
                      disableDensitySelector
                      filterMode="server"
                      onFilterModelChange={onFilterChange}
                      slots={{
                        noRowsOverlay: () => (
                          <Box className="noData">
                            <img src={NodataImg} alt="no data found" />
                          </Box>
                        ),
                        toolbar: (props) =>
                          (CustomGridToolbar({ ...props, moduleType: "courseDiscussionManagement", queryOptions: queryOptions, paginationModel: paginationModel, isDownload: isDownload, setIsDownload: setIsDownload, apiUrl: `api/v1/discussion/comments/${params.id}/replies/` })),
                      }}
                      slotProps={{
                        loadingOverlay: {
                          variant: 'linear-progress',
                          noRowsVariant: 'linear-progress',
                        },
                        toolbar: {
                          showQuickFilter: true,
                        },
                      }}
                    />
                  </Paper>

                </Card>
              </>)}
            </Grid>
          </Grid>
        </form>
      </Body>
      <BackdropUI open={isDownload} />
    </>
  );
}
